import React, { useState } from 'react';
import { Building2, MapPin, FileText, Shield, ChevronDown, ChevronRight } from 'lucide-react';

const Dccwss = () => {
  const [expandedLoan, setExpandedLoan] = useState(null);
  const [showGovernmentSchemes, setShowGovernmentSchemes] = useState(false);
  const [showOtherServices, setShowOtherServices] = useState(false);
  const [showRegulation, setShowRegulation] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (!element) return;

    const yOffset = -120;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const loanProducts = [
    { id: 1, name: "Education Loan" },
    { id: 2, name: "House Appliances Loan" },
    { id: 3, name: "Jewel Loan" },
    { id: 4, name: "Kalaignarin Kanavu Illam Scheme Loan" },
    { id: 5, name: "Loans to Folk Artistes" },
    { id: 6, name: "NFS Loan" },
    { id: 7, name: "Reverse Mortgage Loan" },
    { id: 8, name: "Siragugal Scheme Loan" },
    { id: 9, name: "Vehicle Loan" },
    { id: 10, name: "Loans To Landless Poor Women Agricultural Labourers For Purchase Of Agricultural Land" },
    { id: 11, name: "Loans To FPOs, SHGs And JLGs For Value Addition Of Agro Products" },
    { id: 12, name: "Loans To Economically Backward Women For Purchase of e-Auto" },
    { id: 13, name: "Medium Term Loan" },
    { id: 14, name: "Self Help Groups Loan" },
    { id: 15, name: "Petty Traders Loan" },
    { id: 16, name: "TABCEDCO Loan" },
    { id: 17, name: "TAMCO Loan" },
    { id: 18, name: "TAHDCO Loan" },
    { id: 19, name: "Working Women Loan" },
    { id: 20, name: "Women Entrepreneurs Loan" },
    { id: 21, name: "Differently Abled Persons Loan" },
    { id: 22, name: "MSME Loan" },
    { id: 23, name: "Loans to Destitute Widow Deserted Women" },
    { id: 24, name: "Plot Purchase Loan" },
    { id: 25, name: "Housing and House Mortgage Loan" }
  ];

  const governmentSchemes = [
    "Kalaignarin Kanavu Illam",
    "NEEDS",
    "Siragugal",
    "TABCEDCO",
    "TAHDCO",
    "TAMCO",
    "AABCS"
  ];

  const otherServices = [
    "Customer Safety Locker",
    "Digital Banking and Payment Systems"
  ];

  const toggleLoan = (id) => {
    setExpandedLoan(expandedLoan === id ? null : id);
  };

  return (
    <div className="min-h-screen font-sans flex">

      {/* ---------------- LEFT FIXED MENU ---------------- */}
      <div className="w-72 pt-28">
        <div className="bg-white shadow-sm border border-gray-200 p-6 sticky top-24 font-sans">
          <h3 className="text-2xl font-bold text-gray-900 mb-4 pb-3 border-b">
            Departments
          </h3>

          <div className="text-sm text-gray-800 space-y-4">

            <div className="font-semibold text-gray-900 text-lg">
              Consumer Cooperative
            </div>

            {/* DCCB */}
            <details className="group">
              <summary className="flex justify-between items-center cursor-pointer text-sm font-medium text-gray-800 list-none">
                <button
                  onClick={() => scrollToSection("dccb-heading")}
                  className="text-left font-medium hover:text-blue-600 hover:underline text-lg"
                >
                  DCCB
                </button>

                <span className="transition-transform group-open:rotate-180 text-gray-500">▼</span>
              </summary>

              <div className="mt-2 pl-4 space-y-2 text-sm text-blue-600">
                <button onClick={() => scrollToSection("about-section")} className="block text-left hover:underline text-base">
                  About DCCBs
                </button>
                <button onClick={() => scrollToSection("network-section")} className="block text-left hover:underline text-base">
                  Operational Network
                </button>
                <button onClick={() => scrollToSection("banking-section")} className="block text-left hover:underline text-base">
                  Banking Services
                </button>
                <button onClick={() => scrollToSection("loans-section")} className="block text-left hover:underline text-base">
                  Loan Products
                </button>
                <button onClick={() => scrollToSection("schemes-section")} className="block text-left hover:underline text-base">
                  Government Schemes
                </button>
                <button onClick={() => scrollToSection("services-section")} className="block text-left hover:underline text-base">
                  Other Services
                </button>
                <button onClick={() => scrollToSection("regulation-section")} className="block text-left hover:underline text-base">
                  Policy & Regulation
                </button>
              </div>
            </details>
          </div>
        </div>
      </div>

      {/* ---------------- RIGHT CONTENT ---------------- */}
      <div className="flex-1 overflow-y-auto bg-gray-100">
        <header className="text-center py-10 bg-white border-b -mb-2">
          <h1 className="text-4xl font-bold text-gray-800 text-left">District Central Co-operative Banks</h1>
        </header>

        {/* Gradient Header */}
        <header id="dccb-heading" className="text-center py-10">
          <h1 className="text-4xl font-bold text-gray-800">DCCB</h1>
        </header>

        {/* About Section */}
        <section id="about-section" className="px-6 lg:px-16 py-10">
          <div className="bg-white shadow-sm p-6 rounded-xl border-l-4 border-blue-500">
            <h2 className="text-xl font-semibold mb-3 text-gray-900">About DCCBs</h2>
            <p className="text-gray-700 text-base leading-relaxed">
              District Central Co-operative Banks act as intermediaries between the Apex Bank and Primary Agricultural 
              Co-operative Credit Societies. They extend credit facility to affiliates and offer comprehensive banking 
              services to the public in their area of operation.
            </p>
          </div>
        </section>

        {/* Operational Network */}
        <section id="network-section" className="px-6 lg:px-16 pb-10 bg-white pt-5">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">Operational Network</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <div className="bg-white shadow p-5 rounded-xl flex gap-4 items-start border border-gray-100">
              <div className="bg-blue-50 p-3 rounded-lg text-blue-600">
                <MapPin />
              </div>
              <div>
                <div className="text-3xl font-bold text-gray-900 mb-1">24</div>
                <p className="text-base text-gray-700">District Central Co-operative Banks</p>
              </div>
            </div>
            <div className="bg-white shadow p-5 rounded-xl flex gap-4 items-start border border-gray-100">
              <div className="bg-blue-50 p-3 rounded-lg text-blue-600">
                <Building2 />
              </div>
              <div>
                <div className="text-3xl font-bold text-gray-900 mb-1">934</div>
                <p className="text-base text-gray-700">Branches across Tamil Nadu</p>
              </div>
            </div>
          </div>
        </section>

        {/* Banking Services */}
        <section id="banking-section" className="px-6 lg:px-16 py-10">
          <div className="bg-white shadow-sm p-6 rounded-xl border-l-4 border-blue-500">
            <h2 className="text-xl font-semibold mb-3 text-gray-900">Banking Services</h2>
            <div className="space-y-3">
              <div className="flex gap-3 items-start">
                <div className="bg-blue-50 p-2 rounded text-blue-600">
                  <FileText size={20} />
                </div>
                <p className="text-base text-gray-700">Collection of Deposits</p>
              </div>
              <div className="flex gap-3 items-start">
                <div className="bg-blue-50 p-2 rounded text-blue-600">
                  <FileText size={20} />
                </div>
                <p className="text-base text-gray-700">Cash Credits and Loans to Affiliates</p>
              </div>
              <div className="flex gap-3 items-start">
                <div className="bg-blue-50 p-2 rounded text-blue-600">
                  <FileText size={20} />
                </div>
                <p className="text-base text-gray-700">Loans through own branches</p>
              </div>
            </div>
          </div>
        </section>

        {/* Loan Products */}
        <section id="loans-section" className="px-6 lg:px-16 pb-10 bg-white pt-5">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">Loan Products</h3>
          <div className="bg-white shadow-sm rounded-xl border border-gray-100 overflow-hidden">
            <table className="w-full border-collapse">
              <thead>
                <tr className="bg-blue-50 border-b-2 border-blue-200">
                  <th className="text-left p-3 text-gray-700 font-semibold w-12"></th>
                  <th className="text-left p-3 text-gray-700 font-semibold w-16">S.No</th>
                  <th className="text-left p-3 text-gray-700 font-semibold">Loan Product Name</th>
                </tr>
              </thead>
              <tbody>
                {loanProducts.map((loan) => (
                  <React.Fragment key={loan.id}>
                    <tr 
                      className="border-b border-gray-200 hover:bg-gray-50 cursor-pointer"
                      onClick={() => toggleLoan(loan.id)}
                    >
                      <td className="p-3">
                        {expandedLoan === loan.id ? (
                          <ChevronDown className="text-blue-600" size={20} />
                        ) : (
                          <ChevronRight className="text-gray-400" size={20} />
                        )}
                      </td>
                      <td className="p-3 text-gray-700">{loan.id}</td>
                      <td className="p-3 text-gray-800">{loan.name}</td>
                    </tr>
                    {expandedLoan === loan.id && (
                      <tr>
                        <td colSpan="3" className="bg-gray-50 p-4 border-b border-gray-200">
                          <div className="grid md:grid-cols-2 gap-4">
                            <div>
                              <h4 className="font-semibold text-gray-700 mb-2">Eligibility For Loan</h4>
                              <p className="text-gray-600 italic">Contact bank for details</p>
                            </div>
                            <div>
                              <h4 className="font-semibold text-gray-700 mb-2">Documents Required</h4>
                              <p className="text-gray-600 italic">Contact bank for details</p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        {/* Government Schemes */}
        <section id="schemes-section" className="px-6 lg:px-16 pb-10 bg-gray-100 pt-10">
          <div className="bg-blue-50 shadow p-6 rounded-xl border border-blue-100">
            <div 
              className="cursor-pointer flex items-center justify-between"
              onClick={() => setShowGovernmentSchemes(!showGovernmentSchemes)}
            >
              <h3 className="text-lg font-semibold text-gray-900">Government Scheme Loans</h3>
              {showGovernmentSchemes ? (
                <ChevronDown className="text-blue-600" size={24} />
              ) : (
                <ChevronRight className="text-gray-400" size={24} />
              )}
            </div>
            {showGovernmentSchemes && (
              <div className="mt-4 pt-4 border-t border-blue-200">
                <div className="flex flex-wrap gap-3">
                  {governmentSchemes.map((scheme, index) => (
                    <span 
                      key={index}
                      className="px-4 py-2 bg-white text-blue-700 rounded-full text-sm font-medium border border-blue-200"
                    >
                      {scheme}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>

        {/* Other Services */}
        <section id="services-section" className="px-6 lg:px-16 pb-10 bg-white pt-5">
          <div className="bg-indigo-50 shadow p-6 rounded-xl border border-indigo-100">
            <div 
              className="cursor-pointer flex items-center justify-between"
              onClick={() => setShowOtherServices(!showOtherServices)}
            >
              <h3 className="text-lg font-semibold text-gray-900">Other Services</h3>
              {showOtherServices ? (
                <ChevronDown className="text-blue-600" size={24} />
              ) : (
                <ChevronRight className="text-gray-400" size={24} />
              )}
            </div>
            {showOtherServices && (
              <div className="mt-4 pt-4 border-t border-indigo-200">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {otherServices.map((service, index) => (
                    <div 
                      key={index}
                      className="flex items-center p-4 bg-white rounded-xl border border-indigo-200"
                    >
                      <span className="text-blue-600 mr-2 text-lg">✓</span>
                      <span className="text-gray-800 font-medium text-base">{service}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>

        {/* Policy & Regulation */}
        <section id="regulation-section" className="px-6 lg:px-16 py-10">
          <div className="bg-emerald-50 shadow p-6 rounded-xl border border-emerald-100">
            <div 
              className="cursor-pointer flex items-center justify-between"
              onClick={() => setShowRegulation(!showRegulation)}
            >
              <h3 className="text-lg font-semibold text-gray-900">Policy & Regulation</h3>
              {showRegulation ? (
                <ChevronDown className="text-blue-600" size={24} />
              ) : (
                <ChevronRight className="text-gray-400" size={24} />
              )}
            </div>
            {showRegulation && (
              <div className="mt-4 pt-4 border-t border-emerald-200">
                <p className="text-gray-700 text-base leading-relaxed">
                  Administrative control rests with the <span className="font-semibold text-blue-600">Registrar of Cooperative Societies</span>, 
                  while banking operations are regulated by <span className="font-semibold text-blue-600">RBI</span> and <span className="font-semibold text-blue-600">NABARD</span>.
                </p>
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Dccwss;